module.exports = __webpack_public_path__ + "static/img/icon_partner_eternit.be01ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_eternit.png
// module id = CjaS
// module chunks = 1